export default defineNuxtRouteMiddleware(async (to) => {
  const excludedRoutes = [
    "/",
    "/terms",
    "/privacy",
    "/auth",
    "/auth/callback",
    "/player",
  ]

  // Exclude internal Nuxt paths (assets, dev server, etc.)
  if (to.path.startsWith("/_nuxt") || to.path.startsWith("/__nuxt")) {
    return
  }

  if (to.path === "/terms") {
    return
  }

  const user = await getCurrentUser()

  if (user && to.path === "/") {
    return navigateTo("/app/advanced")
  }

  if (!user && to.path === "/") {
    return
  }

  if (user && to.path === "/auth") {
    return navigateTo("/app")
  }

  if (!user && !excludedRoutes.includes(to.path)) {
    return navigateTo("/auth")
  }
})
